export function getQueryParamsForCollegeListing(
  page: number | null,
  pageSize: number | null
) {
  const baseQuery = {
    ...getQueryForCollegeListingData,
    publicationState: "live",
  };

  // Combine baseQuery with dynamic filters
  const query = {
    ...baseQuery,
    // filters,
  };

  // Add pagination if page and pageSize are provided
  if (page !== null && pageSize !== null) {
    return {
      ...query,
      pagination: {
        page,
        pageSize,
      },
    };
  }

  return query;
}

export const getQueryForCollegeListingData = {
  sort: "display_sequence:asc",
  populate: {
    logo: {
      fields: ["name", "url"],
    },
    state: { fields: ["state_name", "publishedAt"] },
    city: {
      fields: ["city_name", "publishedAt"],
    },
    country: {
      fields: ["country_name"],
    },
    approved_by: {
      fields: ["organisation_name"],
    },
    college_type: { fields: ["college_type"] },
    ranked_by: { fields: ["ranking_body_name"] },
    college_navbars: { fields: ["title"] },
  },
};

// Query to retrieve Geo-Location data
export const getQueryForGeoLocationData = {
  fields: ["country_name", "country_url"],
  populate: {
    states: {
      fields: ["state_name", "state_url"],
      populate: {
        cities: {
          fields: ["city_name", "city_url"],
        },
      },
    },
  },
  publicationState: "live",
  pagination: {
    page: 1,
    pageSize: 1000,
  },
};

// Query to retrieve streams and course data
export const getQueryForCourses = {
  fields: ["course_url", "course_name"],
  publicationState: "live",
  pagination: {
    page: 1,
    pageSize: 1000,
  },
};

// Query to retrieve streams and course data
export const getQueryForStreams = {
  fields: ["stream_name"],
  publicationState: "live",
  pagination: {
    page: 1,
    pageSize: 1000,
  },
};

export const getQueryForProgramTypes = {
  fields: ["program_type"],
  publicationState: "live",
  pagination: {
    page: 1,
    pageSize: 25,
  },
};

export const getFeaturedCollegeQueryParams = (filters: any) => {
  return {
    ...getQueryForCollegeListingData,
    sort: "updatedAt:desc",
    filters: filters,
    publicationState: "live",
    pagination: {
      page: 1,
      pageSize: 10,
    },
  };
};

const bannerQueryParams = {
  sort: "banner_sequence:asc",
  fields: ["banner_post_click_url", "banner_name"],
  populate: {
    banner_image: {
      fields: ["url"],
    },
  },
  publicationState: "live",
  pagination: {
    page: 1,
    pageSize: 25,
  },
};
interface BannerFilter {
  filters?: any;
}

export const getBannerQueryParams = (
  filter: any = { is_default_banner_india: true }
): BannerFilter => {
  return {
    ...bannerQueryParams,
    filters: filter,
  };
};

export const getArticlesQueryParams = (article_url: string) => {
  return {
    fields: ["heading", "article_url", "author_name", "updatedAt"],
    sort: "publishedAt:desc",
    populate: {
      author_image: { fields: ["url"] },
      seo: { fields: ["page_title", "page_description", "keywords"] },
      page_data: {
        on: {
          "article.overview": {
            sort: {
              id: "asc",
            },
          },
        },
      },
      updated_by_user: {
        fields: ["name", "designation","author_bio"],
        populate: {
          profile_picture: { fields: ["url", "name"] },
        },
      },
    },
    filters: {
      article_url: { $eq: article_url },
    },
    publicationState: "live",
    pagination: {
      page: 1,
      pageSize: 10,
    },
  };
};


// Query data for filter section

export const filterInfoDataQueryParams = {
  publicationState: "live",
  pagination: {
    page: 1,
    pageSize: 25000,
  },
  fields: ["college_url"],
  populate: {
    streams: { fields: ["stream_name", "filter_sequence"] },
    course: { fields: ["course_name", "abbreviation", "course_url"] },
    specializations: { fields: ["specialization_name", "specialization_url"] },
    country: { fields: ["country_name", "country_url"] },
    state: { fields: ["state_name", "state_url"] },
    city: { fields: ["city_name", "city_url"] },
  },
};

export const filterSectionStreamQueryParams = {
  publicationState: "live",
  pagination: {
    page: 1,
    pageSize: 1000, // Kept as per your original string
  },
  fields: ["stream_name"], // Extracted from fields[0]
  populate: {
    courses: {
      fields: ["course_url"], // Extracted from populate[courses][fields][0]
    },
  },
};
